import { render, staticRenderFns } from "./showStaff.vue?vue&type=template&id=8942487c"
import script from "./showStaff.vue?vue&type=script&lang=js"
export * from "./showStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports